import {match} from 'ts-pattern';

import type {BulkOperationState} from '../types/api/bulkOperations';

export function getBulkOperationRecoveryAction(state: BulkOperationState) {
  return match(state)
    .with('PARTIALLY_DONE', 'FAILED', () => 'rerunFailed' as const)
    .with('RESOLVE_FAILED', () => 'tryAgain' as const)
    .with('PENDING', 'IN_PROGRESS', 'DONE', () => null)
    .exhaustive();
}
